import { signal } from 'services/SignalsService'

export default class SizeModel {
  constructor() {
    this.createSignal()
  }

  createSignal() {
    signal.on('RESIZE', (value) => this.size = value)
  }

  set size(value) {
    this._size = value
  }

  get size() {
    return this._size
  }

}
